<template>
  <div class="  w-full">
        <Card class="main-card h-full">
            <template #content>

                <div class="mb-3">
                    
                    <MeterGroup :value="orderCompletion" />
                </div>
                
                <TabView @tab-change="switchTab">
                    <TabPanel header="Items">
                        <DataTable :value="data" stripedRows :loading="data? false : true" showGridlines paginator :rows="100" :rowsPerPageOptions="[100, 200, 1000]" v-model:filters="filters" scrollable scrollHeight="30vh" scrollDirection="both" size="small" ref="itemsTable" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" dataKey="id" >
                            <div class="flex justify-content-end flex-wrap mb-1">
                                <div class="flex align-items-center justify-content-center">
                                    <InputText v-model="filters['global'].value" placeholder="Keyword Search" />
                                </div>
                            </div>
                            

                            <Column header="Sl No" >
                                <template #body="slotProps">
                                    {{ slotProps.index + 1 }}
                                </template>
                            </Column>
                            <Column field="name" header="Item" style="min-width: 13rem">
                                <template #body="slotProps">
                                    {{ slotProps.data.name }}
                                </template>
                                <template #filter="{ filterModel }">
                                    <InputText v-model="filterModel.value" type="text" class="p-column-filter" placeholder="Search by name" />
                                </template>
                            </Column>
                            <Column field="packing" header="Packing" >
                                <template #body="slotProps">
                                    {{ slotProps.data.packing }}
                                </template>
                            </Column>
                            <Column field="quantity" header="Quantity"  >
                                <template #body="slotProps">
                                    {{ formatNumber(slotProps.data.quantity) }}
                                </template>
                            </Column>
                            <Column field="rate" header="Rate" >
                                <template #body="slotProps">
                                    {{ formatCurrency(slotProps.data.rate) }}
                                </template>
                            </Column>
                            <Column field="sub_total" header="Sub Total"  >
                                <template #body="slotProps">
                                    {{ formatCurrency(slotProps.data.sub_total) }}
                                </template>
                            </Column>
                            <Column header="Details"  >
                                <template #body="slotProps">
                                    <Button icon="pi pi-info-circle" size="small" severity="secondary" @click="fetchItemDetails(slotProps.data)" raised v-tooltip.top="'View Item Details'"></Button>
                                </template>
                            </Column>
                        </DataTable>
                        
                    </TabPanel>
                    <TabPanel header="Challans">  
                        <DataTable :value="orderChallans" :loading="loading2" stripedRows showGridlines paginator :rows="100" :rowsPerPageOptions="[100, 200, 1000]" scrollable scrollHeight="30vh" scrollDirection="both" size="small" ref="itemsTable" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" dataKey="id" >
                            <Column header="Sl No" >
                                <template #body="slotProps">
                                    {{ slotProps.index + 1 }}
                                </template>
                            </Column>
                            <Column field="dcNo" header="DC No.">
                            <template #body="slotProps">
                                    {{slotProps.data.dcNo}}
                                </template>
                            </Column>
                            <Column field="dcDate" header="DC Date">
                            </Column>
                            <Column field="dept.shortCode" header="Dept"/>
                            <Column field="location.name" header="Location"/>
                            <Column  header="Billed">
                                <template #body="slotProps">
                                    <Tag v-if="slotProps.data.billStatus==0" value="Pending" severity="danger" />
                                    <div class="billClass" v-if="slotProps.data.billStatus !=0">
                                    <label  >{{slotProps.data.billStatus}}</label>
                                    </div>
                                </template>
                            </Column>
                        </DataTable>
                    </TabPanel>

                </TabView>
            </template>
        </Card>


        <Card v-if="challanCard" class="mt-3 h-25rem">
            
            <template #content>
                
                <div class="grid">
                    <div class="col-10">
                        <label class="text-lg">Item: </label>
                        <label class="text-left text-lg font-semibold">{{ item?.name }}</label>
                    </div>
                    
                    <div class="col-2">
                        <label class="text-lg">Qty: </label>
                        <label class="text-left text-lg font-semibold">{{ item!=null ? formatNumber(item.quantity) : 0 }}</label> 
                    </div>
                    
                    <div class="col-10">
                        
                        <ProgressBar :value="item?.completion"></ProgressBar>

                    </div>
                    <div class="col-2">
                        <label class="text-lg">
                            Delivered:  
                        </label>
                         <label class="text-lg font-semibold">
                            {{ item!=null ? formatNumber(item.deliveredQty) : 0 }}
                        </label>
                    </div>
                    
                </div>

                <div class="mt-1 mb-3" >
                    <div>
                        <label class="font-semibold" >Delivery Challan</label>
                    </div>
                    <!-- <Fieldset legend="Delivery Challan"> -->
                        
                        <div v-if="spinnerLoading" class="flex justify-content-center flex-wrap">
                            <div class="flex align-items-center justify-content-center ">
                                <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                            </div>
                        </div>

                        <div v-if="challans.length==0 && spinnerLoading==false">
                            No Data
                        </div>

                        <ScrollPanel v-if="challans.length>0" style="width: 100%; height: 17vh" class="mb-2">
                            <div v-for="(dc, index) in challans" :key="index" class="grid mt-1 mx-2">
                                <div class="col-5">
                                    <div >
                                        {{ index+1 }}. {{ dc.dc }}
                                    </div>
                                </div>
                                <div class="col-2">   
                                    <div >
                                            <Tag :value="dc.status" :severity="statusSeverity(dc.status)"></Tag> 
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div >
                                        <Tag :value="dc.billed" :severity="statusSeverity(dc.billed)"></Tag> 
                                        <!-- {{ dc.billStatus }} -->
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div >
                                        <label v-if="dc.billNo=='NA'" class="font-semibold text-400">
                                            {{ dc.billNo }}
                                        </label>
                                        <label v-else >
                                            {{ dc.billNo }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </ScrollPanel>

                    <!-- </Fieldset> -->
                </div>

            </template>
        </Card>

    </div> 
</template>

<script>
import { fetchPoChallans, itemChallanAndBillDetails } from '@/services/api/v2/apis';
import Button from 'primevue/button';
import Card from 'primevue/card';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import MeterGroup from 'primevue/metergroup';
// import Fieldset from 'primevue/fieldset';
import ProgressBar from 'primevue/progressbar';
import ScrollPanel from 'primevue/scrollpanel';
import TabPanel from 'primevue/tabpanel';
import TabView from 'primevue/tabview';
import Tag from 'primevue/tag';
import { FilterMatchMode } from 'primevue/api'
import InputText from 'primevue/inputtext';

export default {
    props:{
        data:{
            type:Object,
            required:true,
        },
        po:{
            type:Object,
            required:true
        }
    },
    components:{
        Card,
        TabView,
        TabPanel,
        DataTable,
        Column,
        Button,
        ProgressBar,
        MeterGroup,
        // Fieldset,
        Tag,
        ScrollPanel,
        InputText,
    },
    data(){
        return{
            challans:[],
            item:null,
            itemQty:0,
            spinnerLoading:false,
            orderChallans:[],
            loading2:false,
            challanCard:false,
            orderCompletion:[
                {label:'Delivered', value:0}
            ],
            filters: {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                name: { value: null, matchMode: FilterMatchMode.IN },        
                rate: { value: null, matchMode: FilterMatchMode.IN },
            },
        }
    },
    mounted(){
        setTimeout(() => {
            this.orderCompletion[0].value = this.po?.completedPerc;
        }, 50);
    },
    methods:{
        async switchTab(event){
            if(event.index==1){
                this.challanCard = false;
                this.orderChallans = [];
                this.loading2 = true;
                try {
                    const response = await fetchPoChallans(this.$route.params.id);
                    this.orderChallans = response.data;
                    this.loading2 = false;
                } catch (error) {
                    console.log(error.response.data);
                    this.loading2 = false;
                }
            }
            else if(event.index==2){
                console.log('bills tab');
                console.log(this.data);
                
            }
        },
        async fetchItemDetails(item){
            this.challans = [];
            this.spinnerLoading = true;
            this.item = item;

            const response = await itemChallanAndBillDetails(item.id);
            this.challanCard = true; 
            this.challans = response.data;
            this.spinnerLoading = false;
        },
        formatCurrency(value) {
            if (value == null || isNaN(value)) return '-';
            return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
        },
        formatNumber(value) {
                return value.toLocaleString('en-IN');
        },
        statusSeverity(status){
            switch (status) {
                case 'Given':
                    return 'success';
                case 'Received':
                    return 'success';
                case 'Not Given':
                    return 'danger';
                case 'Billed':
                    return 'success';
                case 'Pending':
                    return 'danger';
                case 'Bill Pending':
                    return 'danger';
                default:
                    break;
            }
        }
    },
    
}
</script>

<style>

.billClass {
  border-radius: 10px;
  background-color: rgb(216, 210, 210);
  padding: 2px 5px;
  font-size: 11px;
  width: 120px;
}

</style>
